<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "ConfirmEmail" });
import { Modal } from "../../../../components/index.js";
import { Paragraph } from "../../../../typography/index.js";
import { QUERY_STATE } from "../../../../stores/query.js";
import { SESSION_USER } from "../../services/store.js";
import * as API from "../../services/api.js";
import { onMount } from "svelte";
import { navigate } from "svelte-navigator";
let error;
const confirmEmailViaToken = async (urlToken) => {
    const RESPONSE = await API.confirmEmailViaToken(urlToken);
    if ("error" in RESPONSE) {
        ({ error } = RESPONSE);
    }
    QUERY_STATE.removeParameter("token");
};
onMount(() => {
    const TOKEN = QUERY_STATE.getParameter("token");
    if ($SESSION_USER?._.state === "confirmed") {
        QUERY_STATE.removeParameter("token");
        navigate(window.location.href.replace(window.location.hash, ""), { replace: true });
        return;
    }
    if (typeof TOKEN !== "string") {
        return;
    }
    void confirmEmailViaToken(TOKEN);
});
</script>

{#if error !== undefined}
    <Modal hash = '#confirm-email'>
        <Paragraph css = '!mb-0' label = { error } color = 'error'/>
    </Modal>
{/if}